

export function bindHardSubmit({form, links}){
  links.on('click', handleSubmit(form));
}

function handleSubmit(form){
  return function(e){
    e.preventDefault();
    form.submit();
  }
}


// WEBPACK FOOTER //
// ./src/utilities/submitHelpers/index.js